import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import moment from 'moment';
import {Modal, Table, Loader, Button} from 'semantic-ui-react';
import {ordersTypes} from '../../../../common/dictionaries/accessories';
import {findValueInObjectsArray} from '../../../../common/util/array';
import {fullDate} from '../../../../common/constants/datesFormat';
import {Actions} from '../../../../common/actions';

const {
  fetchOrdersByChassis,
  fetchOrderAndTasksStatus,
} = Actions;

const TableItems = ({list, loading, orderStatusList}) => {
  const renderStatusName = (status) => {
    if (!status) {
      return '';
    }
    return findValueInObjectsArray(
      orderStatusList,
      {'keySearch': 'id', 'valueSearch': status},
      'description'
    );
  };

  if (loading) {
    return (
      <Table.Row className='loader'>
        <Table.Cell colSpan='100%'>
          <Loader active inline='centered' />
        </Table.Cell>
      </Table.Row>
    );
  }

  if (!list.length) {
    return (
      <Table.Row>
        <Table.Cell textAlign='center' colSpan={6}>
          No hay datos Disponibles
        </Table.Cell>
      </Table.Row>
    );
  }

  return list.map((item, index) => {
    const dateFormatted = item.openDate ?
      moment(item.openDate).format(fullDate) :
      '';

    return (
      <Table.Row key={index}>
        <Table.Cell textAlign='center'>{item.orderId}</Table.Cell>
        <Table.Cell textAlign='center'>
          {ordersTypes[item.orderType]}
        </Table.Cell>
        <Table.Cell textAlign='center'>{dateFormatted}</Table.Cell>
        <Table.Cell textAlign='center'>
          {item.creationUser ? item.creationUser.toUpperCase() : ''}
        </Table.Cell>
        <Table.Cell textAlign='center'>
          {renderStatusName(item.statusId)}
        </Table.Cell>
      </Table.Row>
    );
  });
};

const OrdersByChassisModal = ({chassis, onCloseModal, modalWasOpen}) => {
  const vehiclesAvailability = useSelector((state) => state.vehiclesAvailability);
  const orderStatusList = useSelector((state) => state.accessoriesOrders.orderStatusList);
  const dispatch = useDispatch();
  const {loadingOrdersByChassis, ordersByChassis} = vehiclesAvailability;

  useEffect(() => {
    dispatch(fetchOrdersByChassis(chassis, {'hideOrderCancelled': 'yes'}));
    dispatch(fetchOrderAndTasksStatus({'type': 'order'}));
  }, [dispatch]);

  const onCloseModalClick = () => {
    onCloseModal();
  };

  return (
    <Modal size='large' className='stock-download-modal' open={modalWasOpen}>
      <Modal.Header>Órdenes del chasis: {chassis}</Modal.Header>

      <Modal.Content scrolling>
        <Modal.Description>
          <Table striped className='toyota-grid'>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell textAlign='center'>
                    Nro. Orden
                </Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>Tipo</Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>Fecha</Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>
                    Usuario
                </Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>Estado</Table.HeaderCell>
              </Table.Row>
            </Table.Header>

            <Table.Body>
              <TableItems
                loading={loadingOrdersByChassis}
                list={ordersByChassis}
                orderStatusList={orderStatusList}
              />
            </Table.Body>
          </Table>
        </Modal.Description>
      </Modal.Content>

      <Modal.Actions>
        <Button onClick={onCloseModalClick}>Cerrar</Button>
      </Modal.Actions>
    </Modal>
  );
};

export default OrdersByChassisModal;
